import { Helmet } from "react-helmet";
import Blc_partner from "../Blc_Home/Blc_partner/Blc_partner";
import Blc_Gallery_One from "./Blc_Gallery_One";
import Blc_Gallery_Three from "./Blc_Gallery_Three";
import Hero_Section_Gallery from "./Hero_Section_Gallery";



const Blc_Gallery = (props) => {

    return (
        <div>
            <Helmet>
                <title>Our Extensive Photo Gallery | Brac Learning Centre</title>
                <meta name="description" content="Brac Learning Centre's extensive gallery shows the class
rooms, hall rooms, dining rooms, guest rooms and dormitories of their 18 centers." />
                <meta name="keywords" content="BRAC Activities, VIP Guest house, Luxury villas, hall room
facilities for rent, hall room facilities for rent in Bangladesh, meetings & events
venue in Dhaka, business meeting venue in Bangladesh, Learning center for
corporate services, commercial space, commercial space for rent" />
            </Helmet>
            <Hero_Section_Gallery valHero={props.valGallery.heroImg} />
            <Blc_Gallery_One valGalleryTwo={props.valGallery.gallerycard} valGalleryThree={props.valGallery.galleryalbum} />
            {/* <Blc_partner val={props.valPartner}></Blc_partner> */}
            <Blc_Gallery_Three valGalleryTwo={props.valGallery.gallerycard} valGalleryThree={props.valGallery.galleryalbum} />
        </div>
    )
}


export default Blc_Gallery;